export const termination_status = [
    'Current',
    'Surrendered',
    'Renewal',
    'Operation',
    'Break',
    'Merger',
    'Notice',
    'Disclaimer',
    'Forfeiture',
    'Other',
    'Sold',
    'Expired',
  ];

  export const vat_applies = [
    'No',
    'Part',
    'All'
  ];